import { findCourseCategory, sortLectureItems } from "./course-categories";
import { getAllScores } from "./scores-api";
import {
  getRecommendedScenario,
  type StudentScenarioResponse,
} from "./student-course-progress";

export const STUDENT_TASK_BRIEFING_STORAGE_KEY = "student-task-briefing";

export type StudentTaskBriefingPayload = {
  instructionId?: number;
  categoryName: string;
  patientName: string;
  taskTitle: string;
  taskText: string;
  questionnaireText: string | null;
  returnPath?: string;
  hideBack?: boolean;
};

export function isGuestPassUser(user?: { id?: string; email?: string } | null): boolean {
  const id = String(user?.id || "");
  const email = String(user?.email || "").toLowerCase();
  return id.startsWith("guest:") || email.endsWith("@guest.local");
}

export function storeStudentTaskBriefing(input: {
  instructionId: number;
  categoryName?: string;
  patientName?: string;
  taskTitle?: string;
  taskText?: string;
  questionnaireText?: string | null;
  returnPath?: string;
  hideBack?: boolean;
}): string {
  const payload: StudentTaskBriefingPayload = {
    instructionId: input.instructionId,
    categoryName: input.categoryName || "初診時医療面接",
    patientName: input.patientName || "患者",
    taskTitle: input.taskTitle || "課題",
    taskText: input.taskText || input.taskTitle || "課題",
    questionnaireText: input.questionnaireText ?? null,
    returnPath: input.returnPath,
    hideBack: input.hideBack,
  };
  if (typeof window !== "undefined") {
    window.sessionStorage.setItem(STUDENT_TASK_BRIEFING_STORAGE_KEY, JSON.stringify(payload));
  }
  return `/mypage/task-briefing?instructionId=${input.instructionId}`;
}

export async function startRecommendedStudentBriefing(input?: {
  hideBack?: boolean;
  returnPath?: string;
}): Promise<string> {
  const scenarioResponse = await fetch("/api/scenarios", { credentials: "include" }).then(
    async (response) => {
      if (!response.ok) {
        throw new Error("課題を読み込めませんでした。");
      }
      return response.json() as Promise<StudentScenarioResponse>;
    },
  );
  const scoreResponse = await getAllScores().catch(() => ({ scores: [] }));
  const recommended =
    getRecommendedScenario(scenarioResponse, scoreResponse.scores) ??
    sortLectureItems(
      (scenarioResponse.scenarios ?? []).map((scenario) => ({
        ...scenario,
        courseCategoryId: scenario.courseCategoryId ?? null,
      })),
    )[0];
  if (!recommended?.id) {
    throw new Error("開始できる課題がありません。");
  }
  const description =
    recommended.summary?.trim() || recommended.tasks?.[0]?.title || "課題";
  return storeStudentTaskBriefing({
    instructionId: recommended.id,
    categoryName:
      findCourseCategory(recommended.courseCategoryId ?? 0)?.name || "初診時医療面接",
    taskTitle: description,
    taskText: description,
    questionnaireText: recommended.questionnaire ?? null,
    returnPath: input?.returnPath,
    hideBack: input?.hideBack,
  });
}
